export default __webpack_public_path__ + "static/media/twitch.fcd840d0.svg";